import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const ScrollDiscoveryHint = ({ totalCount, label = 'categories', accentColor = 'red' }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 120) setVisible(false);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  const colorMap = {
    red: {
      gradient: 'from-red-500/0 via-red-500/5 to-slate-950',
      pill: 'bg-red-500/15 border-red-500/30 text-red-400',
      chevron: 'text-red-400',
      glow: 'shadow-red-500/20',
    },
    green: {
      gradient: 'from-green-500/0 via-green-500/5 to-slate-950',
      pill: 'bg-emerald-500/15 border-emerald-500/30 text-emerald-400',
      chevron: 'text-emerald-400',
      glow: 'shadow-emerald-500/20',
    },
  };

  const c = colorMap[accentColor] || colorMap.red;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none lg:hidden" data-testid="scroll-discovery-hint">
      {/* Floating pill (gradient fade removed, was causing a dark band on the white sell/repair pages in light mode) */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 pointer-events-auto">
        <button
          onClick={() => {
            window.scrollBy({ top: 300, behavior: 'smooth' });
            setVisible(false);
          }}
          className={`flex items-center gap-2 px-4 py-2 rounded-full border backdrop-blur-md ${c.pill} shadow-lg ${c.glow} animate-[hint-float_2s_ease-in-out_infinite] transition-all duration-300`}
          data-testid="scroll-hint-button"
        >
          <span className="text-xs font-semibold tracking-wide">{totalCount} {label} below</span>
          <ChevronDown className={`w-4 h-4 ${c.chevron} animate-[hint-bounce_1.5s_ease-in-out_infinite]`} />
        </button>
      </div>

      <style>{`
        @keyframes hint-float {
          0%, 100% { transform: translate(-50%, 0); }
          50% { transform: translate(-50%, -4px); }
        }
        @keyframes hint-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(3px); }
        }
      `}</style>
    </div>
  );
};

export default ScrollDiscoveryHint;
